import { ReactNode, useState } from 'react'
import { Popover } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import EventCard from 'screens/Rostering/components/EventCard'
import MonitoringRotaDrawer from './MonitoringRotaDrawer'

type EventsPopoverProps = {
  children: ReactNode
  events?: any[]
}

const EventsPopover = ({ children, events }: EventsPopoverProps) => {
  const { t } = useTranslation()

  if (!events) return null

  const [drawerVisible, setDrawerVisible] = useState(false)
  const [selectedEventId, setSelectedEventId] = useState('')

  const [isOpen, setIsOpen] = useState(false)

  const handleOpenChange = (newOpen: boolean) => {
    setIsOpen(newOpen)
  }

  return (
    <>
      <Popover
        placement="bottomRight"
        showArrow
        trigger="hover"
        arrow={{ pointAtCenter: true }}
        open={isOpen}
        onOpenChange={handleOpenChange}
        content={
          <Container>
            <LightText weight="medium" level={2}>
              {t('EVENTS')}
            </LightText>
            <EventsContainer>
              {events.map((event) => (
                <EventCard
                  key={event.id}
                  event={event}
                  onClick={() => {
                    setSelectedEventId(event.id)
                    setDrawerVisible(true)
                    setIsOpen(false)
                  }}
                />
              ))}
            </EventsContainer>
          </Container>
        }
      >
        {children}
      </Popover>
      {drawerVisible && (
        <MonitoringRotaDrawer
          onClose={() => setDrawerVisible(false)}
          isVisible={drawerVisible}
          revisionId={selectedEventId}
        />
      )}
    </>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px;
`
const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export default EventsPopover
